import { lazy } from "react";
import { Route } from "react-router-dom";

export enum PlatformGuestRoutes {
    OWNER = "/guest/owner",
    INVESTOR = "/guest/investor",
    PROJECT_PROPERTY = "/guest/project-property/:id",
    PROPERTY_TYPE = "/guest/property-type/:id",
    PROPERTY_TYPE_IMAGES = "/guest/property-type/:id/images",
    PROPERTIES = "/guest/properties",
    PROJECT_INVESTOR = "/guest/project-investor/:id",
    CONTRACTS = "/guest/contracts",
    WHATSAPP_CONNECT_SUCCESS = "/whatsapp/connect/success",
    WHATSAPP_CONNECT_FAILED = "/whatsapp/connect/failed",
    MARKETPLACE = "/propiedades",
    MARKETPLACE_DETAIL = "/propiedades/:id",
    DEVELOPERS = "/desarrolladoras",
    DEVELOPER_MARKETPLACE = "/desarrolladora/:id",
}

const ProjectProperty = lazy(() => import("./ProjectProperty"));
const PropertyType = lazy(() => import("./PropertyType"));
const PropertyTypeImages = lazy(() => import("./PropertyTypeImages"));
const Projects = lazy(() => import("./Projects"));
const Properties = lazy(() => import("./Properties"));
const Contracts = lazy(() => import("./Contracts"));
const WhatsAppConnectSuccess = lazy(() => import("module/broker/component/WhatsAppConnectSuccess/WhatsAppConnectSuccess"));
const WhatsAppConnectFailed = lazy(() => import("module/broker/component/WhatsAppConnectFailed/WhatsAppConnectFailed"));
const MarketplaceListPage = lazy(() => import("module/marketplace/page/MarketplaceListPage"));
const PropertyDetailPage = lazy(() => import("module/marketplace/page/PropertyDetailPage"));
const Desarrolladoras = lazy(() => import("./component/core/Desarrolladoras/Desarrolladoras"));
const DeveloperMarketplace = lazy(() => import("./component/core/Desarrolladoras/DeveloperMarketplace"));

export const PlatformGuestRouter = (
    <>
        <Route path={PlatformGuestRoutes.OWNER} element={<Projects isLogged={false} type={"property"} />} />
        <Route path={PlatformGuestRoutes.INVESTOR} element={<Projects isLogged={false} type={"investment"} />} />
        <Route path={PlatformGuestRoutes.PROJECT_PROPERTY} element={<ProjectProperty isLogged={false} type={"property"} />} />
        <Route path={PlatformGuestRoutes.PROPERTY_TYPE_IMAGES} element={<PropertyTypeImages />} />
        <Route path={PlatformGuestRoutes.PROPERTY_TYPE} element={<PropertyType isLogged={false} />} />
        <Route path={PlatformGuestRoutes.PROPERTIES} element={<Properties type={"property"} />} />
        <Route path={PlatformGuestRoutes.PROJECT_INVESTOR} element={<ProjectProperty isLogged={false} type={"investment"} />} />
        <Route path={PlatformGuestRoutes.CONTRACTS} element={<Contracts />} />
        <Route path={PlatformGuestRoutes.MARKETPLACE} element={<MarketplaceListPage />} />
        <Route path={PlatformGuestRoutes.MARKETPLACE_DETAIL} element={<PropertyDetailPage />} />
        <Route path={PlatformGuestRoutes.DEVELOPERS} element={<Desarrolladoras />} />
        <Route path={PlatformGuestRoutes.DEVELOPER_MARKETPLACE} element={<DeveloperMarketplace />} />
        <Route path={PlatformGuestRoutes.WHATSAPP_CONNECT_SUCCESS} element={<WhatsAppConnectSuccess />} />
        <Route path={PlatformGuestRoutes.WHATSAPP_CONNECT_FAILED} element={<WhatsAppConnectFailed />} />
    </>
);
